import { toast } from "react-toastify";
import RequestConfig from "../../mini_components/RequestConfig";
import { handleErrorApi, removeLoSt } from "../../utils/utils";

export async function getProfile() {
  try {
    const session = await RequestConfig.get("/users/profile");
    if (!session) return;

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getUserAvailabelBalance() {
  try {
    const session = await RequestConfig.get("/balance/");
    if (!session) return;

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function handleLoginUser(data) {
  try {
    const session = await RequestConfig.post(`users/login/`, data);

    return session;
  } catch (error) {
    if (error.response?.status === 400) {
      toast.error("اطلاعات وارد گردیده صحیح نمی باشد");
      return;
    }
    handleErrorApi(error);
  }
}
export async function handleForgotPassword(phone = "") {
  try {
    const session = await RequestConfig.post(
      `users/password/forgot/otp/send/`,
      {
        phone: phone,
      }
    );

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function ConfirmOtpTowStepLogin(data) {
  try {
    const session = await RequestConfig.post(`users/login/2fa/otp/confirm/`, {
      otp: data?.otp,
      phone: data?.phone,
    });
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}
export async function ConfirmOtpForgotPassword(data) {
  //console.log(data);
  try {
    const session = await RequestConfig.post(
      `users/password/forgot/otp/confirm/`,
      {
        otp: data?.otp,
        phone: data?.phone,
      }
    );
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}
export async function ChangePassword(data) {
  //console.log(data);
  try {
    const session = await RequestConfig.post(
      `users/password/forgot/update/`,
      data
    );
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}

export async function VerifyOldPassword(old_password) {
  try {
    const session = await RequestConfig.post(
      `/users/password/update/otp/send/`,
      { old_password }
    );
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}
export async function modifyOldPassword(data) {
  try {
    const session = await RequestConfig.post(`/users/password/update/`, data);
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}
export async function getfixedPasswordOtp() {
  try {
    const session = await RequestConfig.post(`/users/fixed_password/otp/send/`);
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}
export async function modifyPaymentFixedPassword(data) {
  try {
    const session = await RequestConfig.post(
      `/users/fixed_password/otp/confirm/`,
      data
    );
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response);
    handleErrorApi(error);
  }
}

export async function excelExport({ searchTermRef, url }) {
  //console.log({ searchTermRef });
  const filteredParams = Object.fromEntries(
    Object.entries(searchTermRef).filter(([key, value]) => value)
  );

  //console.log({ filteredParams });
  const queryParam = new URLSearchParams(filteredParams);
  try {
    const session = await RequestConfig.get(
      `/${url}/excel_export/?${queryParam}`
    );

    return session;
  } catch (error) {
    //console.log(error);
  }
}

export async function getApplications() {
  try {
    const session = await RequestConfig.get("/applications");
    if (!session) return;

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getApiKeys() {
  try {
    const session = await RequestConfig.get("/users/apikeys/");
    if (!session) return;

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function generateApiKey(title) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.post(`/users/apikeys/`, {
      title: title,
    });
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function deleteApiKey(api_key) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.delete(`/users/apikeys/${api_key}/`);
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getDestinationIbans({
  currentPage,
  debouncedQueryParams,
}) {
  const filteredParams = Object.fromEntries(
    Object.entries(debouncedQueryParams).filter(
      ([key, value]) => value !== "" && value !== undefined
    )
  );

  const queryParam = new URLSearchParams(filteredParams);
  const queryParams = [queryParam, `page=${currentPage}`];
  const queryString = queryParams.filter(Boolean).join("&");

  try {
    const session = await RequestConfig.get(
      `/withdraws/destinations/?order_by=id&descending=true&${queryString}`
    );
    if (!session) return;

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getWithdraws({ debouncedQueryParams, currentPage }) {
  const filteredParams = Object.fromEntries(
    Object.entries(debouncedQueryParams).filter(
      ([key, value]) => value !== "" && value !== undefined
    )
  );

  const queryParam = new URLSearchParams(filteredParams);
  const queryParams = [queryParam, `page=${currentPage}`];
  const queryString = queryParams.filter(Boolean).join("&");

  try {
    const session = await RequestConfig.get(
      `/withdraws/?order_by=created_at&descending=true&${queryString}`
    );

    if (!session) toast("لیست مقادیر a نشد.");

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function externalWithdraw(data) {
  const processData = JSON.stringify({
    amount: removeLoSt(data?.amount),
    destination_iban: "IR" + data?.iban,
    description: data?.description,
    iban_nickname: data?.iban_nickname,
  });

  try {
    const session = await RequestConfig.post(
      `withdraws/requests/`,
      processData
    );
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function internalWithdraw(data) {
  const processData = JSON.stringify({
    amount: removeLoSt(data?.amount),
    recipient: data?.mobile,
  });
  try {
    const session = await RequestConfig.post(
      `internal_withdraws/`,
      processData
    );
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getMoneyTransferReqs({ currentPage }) {
  try {
    const session = await RequestConfig.get(
      `withdraws/requests/?ordering=-id&page=${currentPage}`
    );
    return session;
  } catch (error) {
    ////console.log(error, "transactionList");
  }
}

export async function getStatements({ debouncedQueryParams, currentPage }) {
  const filteredParams = Object.fromEntries(
    Object.entries(debouncedQueryParams).filter(
      ([key, value]) => value !== "" && value !== undefined
    )
  );

  const queryParam = new URLSearchParams(filteredParams);
  const queryParams = [queryParam, `page=${currentPage}`];
  const queryString = queryParams.filter(Boolean).join("&");
  //console.log({ currentPage });
  try {
    const session = await RequestConfig.get(
      `/reports/statements/?order_by=id&descending=true&${queryString}`
    );

    if (!session) toast("لیست مقادیر a نشد.");

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getIncomes({ debouncedQueryParams, currentPage }) {
const filteredParams = Object.fromEntries(
  Object.entries(debouncedQueryParams)
    .filter(([key, value]) => {
      if (key === "application") {
        return value?.value; // keep it if it has a non-empty value
      }
      return value !== "" && value !== undefined;
    })
    .map(([key, value]) => {
      if (key === "application") {
        return [key, value?.value ?? null];
      }
      return [key, value];
    })
);


  const queryParam = new URLSearchParams(filteredParams);
  const queryParams = [queryParam, `page=${currentPage}`];
  const queryString = queryParams.filter(Boolean).join("&");
  //console.log({ currentPage });
  try {
    const session = await RequestConfig.get(
      `/incomes/?order_by=id&descending=true&${queryString}`
    );

    if (!session) toast("لیست مقادیر a نشد.");

    return session.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function active2faViaSms(active) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.put(`/users/update/settings/2fa/sms/`, {
      active,
    });
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function confirmOtp2faViaSms({ otp, active }) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.post(
      `/users/update/settings/2fa/sms/confirm/`,
      {
        otp,
        active,
      }
    );
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function active2faViaEmail(active) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.put(
      `/users/update/settings/2fa/email/`,
      {
        active,
      }
    );
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function confirmOtp2faViaEmail({ otp, active }) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.post(
      `/users/update/settings/2fa/email/confirm/`,
      {
        otp,
        active,
      }
    );
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function active2faViaGoogleAuth(active) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.put(
      `/users/update/settings/2fa/google_auth/`,
      {
        active,
      }
    );
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function confirmOtp2faViaGoogleAuth({ otp, active }) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.post(
      `/users/update/settings/2fa/google_auth/confirm/`,
      {
        otp,
        active,
      }
    );
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function updateUserEmail(email) {
  //////console.log(data.data, "api update user");
  try {
    const session = await RequestConfig.patch(`/users/profile/`, { email });
    //////console.log(session, "api update user");
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function createSavedIban(data) {
  const processData = JSON.stringify({
    iban: "IR" + data?.iban,
    iban_nickname: data?.iban_nickname,
  });

  try {
    const session = await RequestConfig.post(
      `withdraws/destinations/`,
      processData
    );
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response, "error.response");
    handleErrorApi(error);
  }
}

export async function updateSavedIban({ data, id }) {
  console.log({ data });
  const processData = JSON.stringify({
    iban: "IR" + data?.iban,
    iban_nickname: data?.iban_nickname,
  });

  try {
    const session = await RequestConfig.patch(
      `withdraws/destinations/${id}/`,
      processData
    );
    //////console.log(session, "sessionsenemail");
    return session;
  } catch (error) {
    //console.log(error.response, "error.response");
    handleErrorApi(error);
  }
}

export async function deleteSavedIban(id) {
  //////console.log(email, otp, "asda");
  try {
    const session = await RequestConfig.delete(
      `/withdraws/destinations/${id}/`
    );
    //////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function updateUserFixedPasswordState(state) {
  try {
    const session = await RequestConfig.patch(`/users/fixed_password/status/`, {
      fixed_password_status: !state,
    });

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
